import React, { ReactNode } from "react";
import styled from "styled-components";
import { Transition } from "react-transition-group";

export const COLLAPSED_TRANSITION_SPEED = 100;

interface CollapserContentsTypes {
  collapsedState: string;
}

const CollapserContents = styled.div<CollapserContentsTypes>`
  opacity: ${({ collapsedState }) => (collapsedState === "entered" ? 1 : 0)};
  transition: opacity ${COLLAPSED_TRANSITION_SPEED}ms ease-in-out;
`;

interface CollapserProps {
  children: ReactNode;
  className?: string;
  isCollapsed: boolean;
}

export const Collapser = ({
  children,
  className,
  isCollapsed = false,
}: CollapserProps) => {
  return (
    <Transition
      mountOnEnter
      unmountOnExit
      className={className}
      in={!isCollapsed}
      timeout={COLLAPSED_TRANSITION_SPEED}
    >
      {collapsedState => (
        <CollapserContents collapsedState={collapsedState}>
          {children}
        </CollapserContents>
      )}
    </Transition>
  );
};
